import { useEffect, useState } from "react";
import { Switch } from "@/components/ui/switch";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useApi } from "@/hooks/useApi";
import { PageHeader, Section, Loading, ErrorBox } from "@/components/common/ui-bits";
import { fmtDateTime } from "@/lib/format";

const ITEMS = [
  { key: "facturas", label: "Facturas y pagos", help: "Aviso al emitir una factura y confirmación de pagos recibidos." },
  { key: "renovaciones", label: "Renovaciones", help: "Recordatorios de vencimiento, solicitudes de aprobación y confirmaciones." },
  { key: "proyectos", label: "Proyectos", help: "Aviso cuando su proyecto es entregado." },
];

function Row({ label, help, checked, onChange, testid }) {
  return (
    <label className="flex items-start justify-between gap-4 py-4">
      <span><span className="block font-semibold text-slate-900">{label}</span><span className="text-sm text-slate-500">{help}</span></span>
      <Switch checked={checked} onCheckedChange={onChange} data-testid={testid} aria-label={label} />
    </label>
  );
}

export default function PortalPreferences() {
  const { data, error, reload } = useApi("/portal/preferences");
  const [v, setV] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { if (data) { setV(data); } }, [data]);
  if (error) return <ErrorBox text={error} />;
  if (!v) return <Loading />;
  const save = async () => {
    setSaving(true);
    try { await api.put("/portal/preferences", { facturas: v.facturas, renovaciones: v.renovaciones, proyectos: v.proyectos, marketing: v.marketing }); toast.success("Preferencias guardadas"); reload(); }
    catch (e) { toast.error(errMsg(e)); } finally { setSaving(false); }
  };
  return (
    <div className="max-w-2xl">
      <PageHeader title="Preferencias de correo" subtitle="Elija qué avisos desea recibir. Puede cambiarlo cuando quiera." />
      <Section title="Avisos de su cuenta" testid="prefs-transactional">
        <div className="divide-y divide-slate-100">{ITEMS.map((i) => <Row key={i.key} {...i} checked={v[i.key]} onChange={(c) => setV({ ...v, [i.key]: c })} testid={`pref-${i.key}`} />)}</div>
      </Section>
      <Section title="Novedades y promociones" className="mt-6" testid="prefs-marketing">
        <Row label="Acepto recibir correos de marketing" help="Novedades, promociones y consejos. Es independiente de los avisos de su cuenta y puede darse de baja en cualquier momento." checked={v.marketing} onChange={(c) => setV({ ...v, marketing: c })} testid="pref-marketing" />
        {data.marketing_at && <p className="text-xs text-slate-500" data-testid="pref-marketing-at">Último cambio: {fmtDateTime(data.marketing_at)}</p>}
      </Section>
      <Button className="mt-6" onClick={save} disabled={saving} data-testid="prefs-save-button">Guardar preferencias</Button>
    </div>
  );
}
